<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <div>
        <PageTitleWithSearch
          :title="'Batch'"
          :btnName="'Create New Batch'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/batches/create'"
          :btnPermission="'batch.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />
        <DataTableWithPagination
          :headers="tableHeaders"
          :items="batchList"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="page = $event"
        >
          <template #row="{ item}">
            <tr :key="item.batch_code" @click="goToGrnDetails(item)">
              <td class="text-left">{{ item.batch_code }}</td>
              <td class="text-left">{{ item.product_code }}</td>
              <td class="text-left">{{ formatDate(item.manufacture_date, dateFormat) }}</td>
              <td class="text-left">
                {{ item.isExpired ? formatDate(item.expiry_date, dateFormat) : "Not expire" }}
              </td>
              <td class="text-right">{{ item.product_prices[0].cost }}</td>
              <td class="text-right">
                {{ item.product_prices[0].retail_price }}
              </td>
              <td class="text-right">
                {{ item.product_prices[0].wholesale_price }}
              </td>
              <td class="text-right">
                <v-btn
                  v-if="hasPermission('batch.edit')"
                  class="ma-1"
                  color="#FFE0B2"
                  :to="'/batches/edit/' + item.id"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  class="ma-1"
                  disabled
                  fab
                  x-small
                  style="box-shadow: none;"
                  ><v-icon small color="#FF9800">mdi-pencil</v-icon></v-btn
                >
              </td>
            </tr>
          </template>
        </DataTableWithPagination>
      </div>
    </v-card>
  </div>
</template>

<script>
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import { BatchService } from "@/services/batch-service.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
import { useDateFormatter } from "../../composables/useDateFormatter.js";

export default {
  name: "batchListTable",
  components: {
    PageTitleWithSearch,
    DataTableWithPagination,
  },
  data() {
    return {
      loading: false,
      search: "",
      batchList: [],
      page: 1,
      total: 0,
      headers: [
        { text: "Batch Code", align: "left", value: "batch_code" },
        { text: "Product Code", align: "left", value: "product_code" },
        {
          text: "Manufactured Date",
          align: "left",
          value: "manufacture_date",
        },
        { text: "Expire Date", align: "left", value: "expiry_date" },
        { text: "Cost", align: "right", value: "cost", isCurrency: true },
        { text: "Retail Price", align: "right", value: "retail_price", isCurrency: true },
        { text: "Wholesale Price", align: "right", value: "wholesale_price", isCurrency: true },
        { text: "Actions", align: "right", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
    ...mapSettingsGetters({
      dateFormat: "dateFormat",
      currencyCode: "currencyCode",
    }),
     tableHeaders() {
      return this.headers.map((h) => {
        if (h.isCurrency) {
          return {
            ...h,
            text: `${h.text} (${this.currencyCode})`, // Add currency code automatically
          };
        }
        return h;
      });
    },
  },
  created() {
    this.fetchBatchList();
  },
  setup() {
    const { formatDate } = useDateFormatter();
    return {
      formatDate,
    };
  },
  watch: {
    search(newSearch) {
      this.fetchBatchList(newSearch);
    },
    page() {
      this.fetchBatchList(this.search);
    },
  },
  methods: {
    async fetchBatchList(search = "") {
      this.loading = true;
      try {
        const response = await BatchService.getBatchList(search, this.page);
        this.batchList = (response.data?.data || []).map((item) => ({
          ...item,
          isExpired: item.isExpired === 1,
        }));
        this.total = response.data?.meta?.last_page || 0;
      } catch (error) {
        this.batchList = [];
        this.total = 0;
        console.error("Error fetching Batch List:", error);
      } finally {
        this.loading = false;
      }
    },
    searchChange(event) {
      this.search = event;
    },
  },
};
</script>
